'use es6';

import { ColorRow, DateRow, PercentageRow, BooleanRow, YesNoRow, DefaultRow } from 'FormsUI/components/comparison/Rows';
import { VALUE_TYPES } from 'FormsUI/constants/ComparisonTool';
import { jsx as _jsx } from "react/jsx-runtime";
const FormattedRowValue = ({
  value,
  valueType,
  fallback
}) => {
  if (!value && valueType !== VALUE_TYPES.BOOLEAN && valueType !== VALUE_TYPES.YES_NO) return fallback;
  switch (valueType) {
    case VALUE_TYPES.COLOR:
      return /*#__PURE__*/_jsx(ColorRow, {
        value: value
      });
    case VALUE_TYPES.DATE:
      return /*#__PURE__*/_jsx(DateRow, {
        value: value
      });
    case VALUE_TYPES.PERCENTAGE:
      return /*#__PURE__*/_jsx(PercentageRow, {
        value: value
      });
    case VALUE_TYPES.BOOLEAN:
      return /*#__PURE__*/_jsx(BooleanRow, {
        value: value
      });
    case VALUE_TYPES.YES_NO:
      return /*#__PURE__*/_jsx(YesNoRow, {
        value: value
      });
    default:
      return /*#__PURE__*/_jsx(DefaultRow, {
        value: value
      });
  }
};
export default FormattedRowValue;